if (!customElements.get('filament-tabs')) {
  customElements.define(
    'filament-tabs',
    class FilamentTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.tabs = Array.from(this.querySelectorAll('[data-filament-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-filament-panel]'));
        this.viewAll = this.querySelector('[data-filament-view-all]');
        if (!this.tabs.length || !this.panels.length) return;

        this.dataset.initialized = 'true';
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      onClick = (event) => {
        const tab = event.target.closest('[data-filament-tab]');
        if (!tab || !this.contains(tab)) return;
        this.activateTab(tab);
      };

      onKeydown = (event) => {
        const currentIndex = this.tabs.indexOf(event.target);
        const handledKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (currentIndex === -1 || !handledKeys.includes(event.key)) return;

        event.preventDefault();
        let nextIndex = currentIndex;

        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else {
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
        }

        this.activateTab(this.tabs[nextIndex]);
        this.tabs[nextIndex].focus();
      };

      activateTab(activeTab) {
        if (activeTab.getAttribute('aria-selected') === 'true') return;

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === activeTab.getAttribute('aria-controls');
          panel.hidden = !isActive;
          panel.classList.remove('is-entering');
          if (isActive) requestAnimationFrame(() => panel.classList.add('is-entering'));
        });

        if (this.viewAll && activeTab.dataset.collectionUrl) {
          this.viewAll.href = activeTab.dataset.collectionUrl;
        }

        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  );
}
